import { useEffect, useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { createContact, logOutApi, detailContact, updateContact } from '../../../Context/api';
import { basicProfileValidation } from '../../../Context/validation';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { isValidPhoneNumber } from 'react-phone-number-input';

const UseAddContact = () => {
    const [spinner, setSpinner] = useState(false)
    const userData = JSON.parse(localStorage.getItem('userData'));
    const navigate = useNavigate()
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            getContact()
        }
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: userData.deviceId, userId: userData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('userData')
                navigate('/')
            }
        })
    }
    const getContact = () => {
        axios.post(detailContact(), { id: id }, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                addContact.setValues(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const addContact = useFormik({
        initialValues: {
            name: '',
            email: '',
            mobileNo: '',
        },
        validationSchema: basicProfileValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                mobileNo: `${values.mobileNo}`,
                email: values.email,
                providerId: userData?.userId,
                type: "SERVICE_PROVIDER",
                isGroup: false
            }
            if (id) {
                data.id = id
            }
            // console.log(data, 'PPPPPPPPPPPPPPPPPP')
            // return
            setSpinner(true)
            axios.post(id ? updateContact() : createContact(), { ...data }, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                        addContact.resetForm()
                    }, 1000);
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })

        }

    })
    return {
        navigate,
        addContact,
        spinner,

    }
}

export default UseAddContact